import { Flex, Input, SearchIcon } from "@fluentui/react-northstar";
import BreadcrumbFolders from "../../components/breadcrumb/BreadcrumbFolders";
import {
    ButtonReset,
    DropdownFilter,
    TableFiles,
} from "../../styles/index.styles";
import { DateRangePickerOneMonth } from "../../../../components/DateRangePicker/DateRangePickerOneMonth";
import useLogicDocumentsHrCommon, {
    QUERY_KEY_DOCUMENTS_HR_GET_FILES_COMMON,
} from "../../hooks/useLogicDocumentHrCommon";
import { GlobeRegular } from "@fluentui/react-icons";
import BarTools from "../../components/toolbar/BarTools";
import DialogAddDocument from "../../components/DialogAddDocument/DialogAddDocument";

const HrDocumentsCommonDocuments = () => {
    const { functions, table, breadcrumb, query, toolbar, filter } =
        useLogicDocumentsHrCommon();
    return (
        <Flex column gap="gap.medium" fill>
            {/* breadcrumb */}
            <Flex gap="gap.small" space="between">
                <BreadcrumbFolders
                    breadcrumb={breadcrumb}
                    onClickBreadcrumbItem={functions.handleBreadcrumbItemClick}
                    icon={<GlobeRegular fontSize={24} />}
                />
                {/* ajouter un document */}
                <DialogAddDocument
                    showAdditionalInformation={false}
                    queryKeyToRefesh={QUERY_KEY_DOCUMENTS_HR_GET_FILES_COMMON}
                    showActions={false}
                    onSuccess={() => {
                        return functions.refetch();
                    }}
                />
            </Flex>
            {/* filters */}
            <Flex gap="gap.medium">
                <Flex>
                    <Input
                        onChange={filter.onChangeSearchQuery}
                        value={filter.searchQuery ?? ""}
                        placeholder="Rechercher un document"
                        icon={<SearchIcon />}
                        iconPosition="end"
                        fluid
                        inverted
                        clearable
                        styles={{
                            border: "1px solid rgb(209, 209, 209)",
                            borderRadius: "4px",
                            width: "312px",
                        }}
                    />
                </Flex>
                <Flex>
                    <DropdownFilter
                        placeholder="Ajouté par"
                        items={filter.user_departments.data}
                        onChange={filter.onChangeUsersDepartments}
                        value={
                            filter.usersState?.length > 0
                                ? filter.usersState
                                : filter.user_departments.data.find((option) =>
                                      filter.defaultSelectedUsers.includes(
                                          option.key
                                      )
                                  ) ?? []
                        }
                        multiple
                        inverted
                        search
                    />
                </Flex>
                <Flex>
                    <DateRangePickerOneMonth
                        resetDatesToNull={filter.resetDatesToNull}
                        defaultStartDate={filter.searchParams.get("sd")}
                        defaultEndDate={filter.searchParams.get("ed")}
                        onDatesChange={filter.onDatesChange}
                    />
                </Flex>
                <div>
                    <ButtonReset
                        text
                        disabled={filter.disable_reset_button}
                        className={
                            filter.disable_reset_button ? "disabled" : ""
                        }
                        onClick={() => {
                            filter.setResetDatesToNull(new Date().getTime());
                            filter.setUsersState([]);
                            filter.setSearchQuery("");
                            return filter.setSearchParams();
                        }}
                    >
                        Réinitialiser
                    </ButtonReset>
                </div>
            </Flex>
            {/* tableau */}
            <Flex
                fill
                column
                styles={{
                    position: "relative",
                    minHeight: "400px",
                }}
            >
                <TableFiles
                    variables={{
                        cellContentOverflow: "none",
                    }}
                    header={
                        query.isLoading || query.isFetching
                            ? table.skeleton_header
                            : table.header
                    }
                    rows={
                        query.isLoading || query.isFetching
                            ? table.skeleton
                            : table.rows
                    }
                />
                {/* selections + download + delete items */}
                {toolbar.show && (
                    <BarTools
                        counterSelection={toolbar.counter}
                        disableDelete={toolbar.disableDelete}
                        isDownloading={toolbar.isDownloadingDocumentMultiple}
                        isDeleting={toolbar.isDeletingDocumentMultiple}
                        onClickDeleteMultiple={
                            toolbar.mutateDeleteDocumentMultiple
                        }
                        onClickDownloadMultiple={
                            toolbar.mutateDownloadDocumentMultiple
                        }
                        onReset={() => functions.handleCheckAll(false)}
                    />
                )}
            </Flex>
        </Flex>
    );
};

export default HrDocumentsCommonDocuments;
